import React from 'react';
import './styles.scoped.css';

const FormContainer = ({ title, children, className = '', style = {}, ...rest }) => (
    <div style={style}>
        {title && <div className="form-header">{title}</div>}
        <div className="form-body">
            <form
                className={`form-container ${className}`}
                role="form"
                aria-label={title}
                noValidate
                onSubmit={e => e.preventDefault()}
                {...rest}
            >
                {children}
            </form>
        </div>
    </div>
);

export default FormContainer;
